<template>
	<div>
		<search-overview
			:search-overview-settings="searchOverviewSettings"
			:category-title="categoryTitle"
			:category-text="categoryText"
			:category-image="categoryImage"
			:azure-search-index-name="azureSearchIndexName"
			:no-results-text="noResultsText"
			:is-logged-in="isLoggedIn"
			:as-search-result="isSearchResult"
			:category-is-pdp="categoryIsPdp"
			:product-detail-code="productDetailCode"
		/>
	</div>
</template>
<script>
// import Product from './Scripts/modules/products/components/general/Product.vue';
import SearchOverview from '../../modules/products/components/SearchOverview.vue';
import searchOverviewSettings from '../../modules/products/domain/searchOverviewSettings.js';

export default {
	components: {
		SearchOverview
	},
	// eslint-disable-next-line vue/require-prop-types
	props: ['data'],
	data() {
		return {
			searchOverviewSettings,
			combinedParentKey: this.data.combinedParentKey,
			categoryTitle: this.data.categoryTitle,
			categoryImage: this.data.categoryImage,
			categoryText: this.data.categoryText,
			categoryIsPdp: this.data.categoryIsPdp === 'True',
			azureSearchIndexName: this.data.azureSearchIndexName,
			azureSearchQuery: this.data.azureSearchQuery,
			noResultsText: this.data.noResultsText,
			isLoggedIn: this.data.isLoggedIn === 'True',
			isSearchResult: this.data.isSearch === 'true',
			productDetailCode: this.data.productDetailCode
		};
	},
	created() {
		this.searchOverviewSettings = Object.assign({}, searchOverviewSettings);
		this.searchOverviewSettings.searchSettings.searchRequest.filter = this.combinedParentKey ? `CombinedParentKeys/any(g: g eq '${this.combinedParentKey}')` : '';
		this.searchOverviewSettings.searchSettings.searchRequest.search = this.azureSearchQuery;
		this.searchOverviewSettings.searchSettings.searchRequest.facets.push('EtimKenmerken/Facet,count:10000,sort:value');
		this.searchOverviewSettings.facetSettings.push({
			key: 'EtimKenmerken/Facet',
			value: 'Complex'
		});
	}
};
</script>
